import {extractorMixin} from 'vuelidate-error-extractor'

export default {
  mixins: [extractorMixin],
  render: function() {
    return this.$scopedSlots.default({
      errors: this.hasErrors ? [this.firstErrorMessage] : [],
    })
  },
}



// WEBPACK FOOTER //
// ./src/components/InputErrorWrapper.js